export const HOST_HUB_TAB_IDS = {
  metrics: "metrics",
  overview: "overview",
} as const;

const HOST_HUB_BASE_PATH = "/host-hub";

export const HOST_HUB_TAB_PATHS = {
  [HOST_HUB_TAB_IDS.metrics]: `${HOST_HUB_BASE_PATH}/metrics`,
  [HOST_HUB_TAB_IDS.overview]: HOST_HUB_BASE_PATH,
} as const;
